const initialState = {
  jobBudgets: [],
  currentBudget: null,
  budgetSummary: null,
  loading: false,
};

const jobBudgetReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'jobBudgets':
      return { ...state, jobBudgets: action.payload };
    case 'currentBudget':
      return { ...state, currentBudget: action.payload };
    case 'budgetSummary':
      return { ...state, budgetSummary: action.payload };
    case 'budgetLoading':
      return { ...state, loading: action.payload };
    default:
      return state;
  }
};

export default jobBudgetReducer;
